import { NotificationContainer } from 'react-notifications';
import { AuthProvider } from './auth';
import { FiltersProvider } from './projectFilters';
import { FavoritesProvider } from './favorites';
import { ThemeProvider } from './theme';

const AppProvider = ({ children }) => (
  <ThemeProvider>
    <AuthProvider>
      <NotificationContainer />
      <FavoritesProvider>
        <FiltersProvider>{children}</FiltersProvider>
      </FavoritesProvider>
    </AuthProvider>
  </ThemeProvider>
);

export default AppProvider;
